export default __webpack_public_path__ + "static/media/GothamSSm-Light.86cb0ca2.ttf";